<!-- @ts-nocheck -->
<template>
  <div>
    <q-select
      v-model="localvalue"
      filled
      :multiple="true"
      dense
      input-debounce="0"
      :options="curOptions"
      :disabled="disabled"
      :disable="disabled"
      :readonly="disabled"
      :label="getLabel()"
      style="padding-bottom: 0"
      input-style="height: 100px;"
    >
      <template v-slot:prepend>
        <q-icon name="filter_alt" @click.stop.prevent />
      </template>
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps" @click="userInteracted">
          <q-item-section>
            <q-item-label>
              {{ scope.opt.label }}<q-icon v-if="scope.opt.hidden" name="mdi-eye-off"
            /></q-item-label>
            <q-item-label v-if="scope.opt.sublabel" caption>{{ scope.opt.sublabel }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:append>
        <q-icon
          v-if="localvalue && localvalue.length > 0"
          name="cancel"
          @click="
            localvalue = [];
            userInteracted();
          "
          class="cursor-pointer q-field__focusable-action"
        ></q-icon>
      </template>
    </q-select>
  </div>
</template>
<script lang="ts">
// @ts-nocheck
import { Options, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import { QSelect } from "quasar";

export type optiontype = {
  label: string;
  value: any;
  grouptext?: string;
  sublabel?: string;
  hidden?: boolean;
};

@Options({
  components: { QSelect }
})
export default class App extends Vue {
  name = "IstMultipleSelect";
  ldense = false;
  curOptions: Array<optiontype> = [];
  localvalue: any = null;
  OldGroupTxt = "";
  oldValue: any = null;

  @Prop({ default: null, type: [String, Number, Object, Array] })
  modelValue!: any;
  @Prop()
  disabled!: boolean;
  @Prop()
  label!: string;
  @Prop()
  options!: Array<optiontype>;
  @Prop({ default: false })
  dense!: boolean;
  @Prop()
  inputStyle!: string;

  @Emit("input")
  @Emit("change")
  @Emit("update:modelValue")
  updateValue() {
    this.$emit("input", this.localvalue);
    this.$emit("change", this.localvalue);
    this.$emit("update:modelValue", this.localvalue);
    return this.localvalue;
  }

  @Emit("userInteracted")
  userInteracted() {
    return true;
  }

  @Watch("modelValue")
  @Watch("localvalue")
  onValueChanged(val: any) {
    if (val) {
      try {
        this.localvalue = val;
      } catch (e) {
        this.localvalue = undefined;
      }
    } else {
      this.localvalue = undefined;
    }
    let tmpValue = this.localvalue;
    if (!tmpValue || (tmpValue.length === 1 && !tmpValue[0])) {
      return;
    }

    let changed = false;
    if (!this.oldValue || this.oldValue.length !== this.localvalue.length) {
      changed = true;
      this.oldValue = JSON.parse(JSON.stringify(this.localvalue));
    } else {
      for (let index = 0; index < this.localvalue.length; index++) {
        const localItem = this.localvalue[index];
        const oldItem = this.oldValue.find((item) => item.value === localItem.value);
        if (!oldItem) {
          changed = true;
          this.oldValue = JSON.parse(JSON.stringify(this.localvalue));
          break;
        }
      }
    }
    if (changed) {
      this.$emit("change", this.localvalue);
      this.$emit("update:modelValue", this.localvalue);
    }
  }

  @Watch("dense")
  onDenseChanged(val: any) {
    this.ldense = val;
  }

  @Watch("options")
  onOptionsChanged(val: any) {
    this.curOptions = val;
    let oldtxt = "";
    for (let index = 0; index < this.curOptions.length; index++) {
      const element = this.curOptions[index];
      const s = element.grouptext ? element.grouptext : "";

      if (s !== "" && oldtxt != s) {
        oldtxt = s;
      } else {
        element.grouptext = undefined;
      }
    }
  }

  mounted() {
    this.localvalue = this.modelValue;
    this.curOptions = this.options;
    this.onOptionsChanged(this.options);
  }

  showGroupText(groupText: string, index: number) {
    if (index === 0) {
      return groupText === "" ? false : true;
    }
    const previusOption = this.curOptions[index - 1];
    return previusOption.grouptext !== groupText && groupText !== "" ? true : false;
  }

  getLabel() {
    if (!this.label) {
      return undefined;
    }
    let s: string = this.label.charAt(0).toUpperCase() + this.label.substring(1).toLowerCase();
    return s ? s : undefined;
  }
}
</script>
<style scoped>
.showerror {
  padding-bottom: 20px !important;
}
:deep(.q-field--auto-height.q-field--dense .q-field__control) {
  min-height: 60px;
  height: auto;
}

:deep(.q-field--dense .q-field__append) {
  padding-top: 22px;
}
</style>
